import { render } from "./ContantCard.vue?vue&type=template&id=0416363e&scoped=true"
import script from "./ContantCard.vue?vue&type=script&lang=js"
export * from "./ContantCard.vue?vue&type=script&lang=js"

import "./ContantCard.vue?vue&type=style&index=0&id=0416363e&lang=scss&scoped=true"

import exportComponent from "C:\\BEST develop\\EJF\\best_ejf15\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0416363e"]])

export default __exports__